// extracted by mini-css-extract-plugin
export default {"cancelModal":"CancelPaymentModal_cancelModal__LbO67","cancelModalContent":"CancelPaymentModal_cancelModalContent__6CD3s"};